import { Survey } from '@/api/surveys';
import SurveyAssignWizard from '@/components/assignments/SurveyAssignWizard';
import { useModalContext } from '@/components/ui/modal-provider';
import { Patient } from '@/types/patient';

interface Props {
    survey: Survey;
    preSelectedPatient?: Patient;
}

export default function SendSurveyDialog({ survey, preSelectedPatient }: Props) {
    const { closeModal } = useModalContext();
    return (
        <SurveyAssignWizard
            survey={survey}
            preSelectedPatient={preSelectedPatient}
            onClose={closeModal}
        />
    );
}
